import { Skeleton } from "@dash/skeleton";
import { Table, TableBody, TableHeadColumn, TableRowProps } from "@dash/table";
import { useTheme } from "@emotion/react";

import { Row, SyncError } from "@megaron/import-export";

type Props<T extends Row> = {
  isLoading: boolean;
  errors: SyncError[] | undefined;
  labels: { [key in keyof T]?: string };
};

export const SyncErrorsTable = <T extends Row>(props: Props<T>) => {
  const theme = useTheme();

  if (!props.errors || props.errors.length === 0) return null;

  const allColumns: TableHeadColumn<string>[] = [
    { label: "Id" },
    { label: "Błąd" },
    { label: "Pole" },
    { label: "Wartość" },
  ];

  const rows: TableRowProps[] = props.errors.map((err) => ({
    cellsContent: [
      {
        element: err.id,
        cellCss: {
          background: theme.colors.dangerBackground,
          color: theme.colors.danger,
          fontWeight: 700,
        },
      },
      {
        element: err.message,
        cellCss: {},
      },
      { element: err.field },
      { element: err.value },
    ],
  }));

  return (
    <div css={{ overflow: "auto" }}>
      <Table
        columns={allColumns}
        css={{
          whiteSpace: "nowrap",
          "td:first-child": {
            padding: "0.75rem",
          },
        }}
      >
        <TableBody isLoading={props.isLoading} rows={rows} />
      </Table>
    </div>
  );
};
